import $ from 'jquery';

const stickyHeaderHeight = $( '.c-header__bottom' ).outerHeight();

$( '.c-jump-nav__link' ).on('click', function(event) {
	if (
		location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
		&&
		location.hostname == this.hostname
	) {
		var target = $( this.hash );
		target = target.length ? target : $(' [name=' + this.hash.slice(1) + '] ');
		if ( target.length ) {
			event.preventDefault();
			$( 'html, body' ).animate({
				scrollTop: target.offset().top - stickyHeaderHeight
			}, 1000);
		}
	}
} );
